import { render, staticRenderFns } from "./dispatchReport.vue?vue&type=template&id=4dbd18ee&scoped=true&"
import script from "./dispatchReport.vue?vue&type=script&lang=js&"
export * from "./dispatchReport.vue?vue&type=script&lang=js&"
import style0 from "./dispatchReport.vue?vue&type=style&index=0&id=4dbd18ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbd18ee",
  null
  
)

export default component.exports